import { render, staticRenderFns } from "./quanxianxinzeng.vue?vue&type=template&id=0fb9990a&scoped=true"
import script from "./quanxianxinzeng.vue?vue&type=script&lang=js"
export * from "./quanxianxinzeng.vue?vue&type=script&lang=js"
import style0 from "./quanxianxinzeng.vue?vue&type=style&index=0&id=0fb9990a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9990a",
  null
  
)

export default component.exports